const header = "_uxsh5983h4";
const heading = "_uxsh76zpeg";
const backlinkWrapper = "_uxsb1vpqo1d";
const backlinkPill = "_uxsb1o2afwi";
const backlink = "_uxsban56jw";

export { backlink, backlinkPill, backlinkWrapper, header, heading };
import "./header.context.style.linaria.module.css";
//# sourceMappingURL=header.context.style.js.map
